import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  Renderer2
} from '@angular/core';

/**
 * `<labs-vertical-spacing>` is a component that is only concerned with
 * applying vertical outer component spacing. The current supported size
 * values are between **1** and **10**.
 */
@Component({
  selector: 'labs-vertical-spacing',
  template: '<ng-content></ng-content>',
  styleUrls: ['./vertical-spacing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerticalSpacingComponent {
  @Input()
  set size(value: number) {
    if (value !== this._size) {
      this.removeClasses(this.elementRef.nativeElement, 'size', this._size);
      this.addClasses(this.elementRef.nativeElement, 'size', value);

      this._size = value;
    }
  }

  /**
   * @ignore
   */
  private _size: number;

  @Input()
  set sizeTop(value: number) {
    if (value !== this._sizeTop) {
      this.removeClasses(
        this.elementRef.nativeElement,
        'size-top',
        this._sizeTop
      );
      this.addClasses(this.elementRef.nativeElement, 'size-top', value);

      this._sizeTop = value;
    }
  }

  /**
   * @ignore
   */
  private _sizeTop: number;

  @Input()
  set sizeBottom(value: number) {
    if (value !== this._sizeBottom) {
      this.removeClasses(
        this.elementRef.nativeElement,
        'size-bottom',
        this._sizeBottom
      );
      this.addClasses(this.elementRef.nativeElement, 'size-bottom', value);

      this._sizeBottom = value;
    }
  }

  /**
   * @ignore
   */
  private _sizeBottom: number;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  private addClasses(element: HTMLElement, classPrefix: string, value: number) {
    if (typeof value === 'undefined') {
      return;
    }

    this.renderer.addClass(element, `${classPrefix}-${value}`);
  }

  private removeClasses(
    element: HTMLElement,
    classPrefix: string,
    value: number
  ) {
    if (typeof value === 'undefined') {
      return;
    }

    this.renderer.removeClass(element, `${classPrefix}-${value}`);
  }
}
